// eslint-disable-next-line @juvare/custom-rules/no-restricted-backend-feature-imports,no-restricted-imports
import { filterOrganizationTreeItems, orgTreePublicDataKey } from '../../../../backend/features/organizations/shared';
import { filterOrganizationTreeItemsByFieldFilter } from '../../../../ui/features/organizations/components/OrganizationsPanel/utils/filterOrganizationTreeItemsByFieldFilter';
import { selectInitialOrgs } from '../../../../ui/features/organizations/components/OrganizationsPanel/utils/selectInitialOrgs';
import { useDataTreeUsingState } from '@juvare/common-data-table-ui/DataTree';
import { usePublicDataGet } from '@juvare/platform-sdk-react/ui/hooks/usePublicDataGet';
import React from 'react';
import { mapOrganizationFilterData } from './useOrganizationsTree';
export function useOrganizationsSelectionTreeAnonymous({ useDataTreeFunction = useDataTreeUsingState, initialSelectedOrganizationIds, filteredOrganizationsIds, }) {
    var _a;
    const orgTree = React.useRef([]);
    const params = {
        useDataProvider: (request) => {
            const { data: organizationsTreeData, isLoading, error, mutate, } = usePublicDataGet(orgTreePublicDataKey);
            const data = React.useMemo(() => {
                const selectedOrganizations = filterOrganizationTreeItems(organizationsTreeData !== null && organizationsTreeData !== void 0 ? organizationsTreeData : [], (item) => {
                    if (filteredOrganizationsIds) {
                        return filteredOrganizationsIds === null || filteredOrganizationsIds === void 0 ? void 0 : filteredOrganizationsIds.includes(item.id.split('_')[0]);
                    }
                    return true;
                });
                // Apply any filters
                const filterResult = filterOrganizationTreeItemsByFieldFilter(selectedOrganizations, mapOrganizationFilterData({ search: request.filterData.search }));
                orgTree.current = filterResult.organizations;
                return {
                    items: filterResult.organizations,
                    highlightedItemIds: filterResult.highlightedOrganizationIds,
                };
                // eslint-disable-next-line react-hooks/exhaustive-deps
            }, [request.filterData.search, filteredOrganizationsIds, initialSelectedOrganizationIds, organizationsTreeData]);
            return {
                data,
                error: error,
                reload: () => mutate,
                isLoading: isLoading,
            };
        },
    };
    const { dataTreeProps, filtersBarProps, appliedFilterData, reload } = useDataTreeFunction(Object.assign(Object.assign({}, params), { initialSelectedItemIds: selectInitialOrgs(initialSelectedOrganizationIds !== null && initialSelectedOrganizationIds !== void 0 ? initialSelectedOrganizationIds : [], orgTree.current) }));
    const defaultDataTreeProps = Object.assign(Object.assign({}, dataTreeProps), { 'data-test': 'organization-tree' });
    const selectedOrganizationIds = React.useMemo(() => {
        var _a;
        return (_a = dataTreeProps.selectedItemIds) === null || _a === void 0 ? void 0 : _a.map((id) => id.split('_')[0]);
    }, [dataTreeProps.selectedItemIds]);
    return {
        dataTreeProps: defaultDataTreeProps,
        filtersBarProps,
        appliedFilterData,
        reload,
        activeOrganizationId: (_a = dataTreeProps.activeItemId) === null || _a === void 0 ? void 0 : _a.split('_')[0],
        selectedOrganizationIds,
    };
}
